export default "__VITE_ASSET__WFk8$H9N__"